export class ILocationImplementationStep {
  id:number;
  location_id:number;
  impl_step_id:number;
  datetime:string;
  user_id:number;
}
